import { render, staticRenderFns } from "./ViewButton.vue?vue&type=template&id=cd554b0e&scoped=true&"
import script from "./ViewButton.vue?vue&type=script&lang=js&"
export * from "./ViewButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd554b0e",
  null
  
)

export default component.exports